<template>
    <div class="flex relative my-auto container mx-auto">

      <PrevArrow prev="sub-offer-three"/>

      <div class="subsection-big-circle bg-black rounded-full mx-auto">
        <h1 class="deep-info-sub-heading text-white mx-auto pt-20 text-2xl font-bold">ACQUISITION</h1>
        <p class="text-teal mt-8 text-4xl font-bold leading-tight">THE WINNING OF <br>MORE USERS</p>
      </div>

      <NextArrow next="sub-offer-five"/>

    </div>
</template>

<script>
import PrevArrow from "@/components/deepinfo/subnavigation/PrevArrow.vue";
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "OfferSubFour",
  components:{
    PrevArrow,
    NextArrow
  }
}
</script>
